import { Clock } from 'three';
import BackgroundScene from './BackgroundScene.js';
import ForegroundScene from './ForegroundScene.js';
import Sizes from '../utils/Sizes.js';
import Camera from './Camera.js';
import Renderer from './Renderer.js';
import Input from '../utils/Input.js';

export default class StartupHotline {
    constructor(canvas) {
        // Singleton pattern
        if (StartupHotline.instance) {
            return StartupHotline.instance;
        }
        StartupHotline.instance = this;

        // Setup
        this.canvas = canvas;
        this.container = canvas.parentElement;
        this.sizes = Sizes.getInstance(this.container)

        // Time management
        this.time = 0;
        this.clock = new Clock();

        // Movement speed
        this.movementSpeed = 0.05;

        // Initialize components
        this.init();
        this.backgroundScene = BackgroundScene.getInstance();
        this.foregroundScene = ForegroundScene.getInstance();

        // Setup event listeners
        this.setupResize();

        // Initial resize
        this.resize();

        // Start render loop
        this.render();
    }

    // Static method to get the instance
    static getInstance() {
        if (!StartupHotline.instance) {
            throw new Error('Experience instance not created yet. Call new Experience(canvas) first.');
        }
        return StartupHotline.instance;
    }

    init() {
        this.camera = Camera.getInstance();
        this.renderer = Renderer.getInstance(this.canvas);
        this.input = Input.getInstance();
    }

    setupResize() {
        this.sizes.on('resize', this.resize.bind(this));
    }

    resize() {
        // Update world components
        if (this.backgroundScene) this.backgroundScene.resize();
        if (this.foregroundScene) this.foregroundScene.resize();
    }

    render() {
        const delta = this.clock.getDelta();
        this.time += delta;
        this.input.update();

        // Update world components
        if (this.backgroundScene) this.backgroundScene.update(delta, this.movementSpeed);

        if (this.renderer) {
            this.renderer.renderBackground(this.backgroundScene.getScene(), this.camera.cameraBackground);
        }

        if (this.foregroundScene) {
            if(this.backgroundScene && this.renderer) {
                const renderedTexture = this.renderer.getRenderedTexture();
                if (renderedTexture) {
                    this.foregroundScene.updateBackgroundTexture(renderedTexture);
                }
            }
            this.foregroundScene.update(delta);
        }

        if (this.renderer) this.renderer.renderForeground(this.foregroundScene.getScene(), this.camera.cameraForeground);

        // Call render again on the next frame
        window.requestAnimationFrame(this.render.bind(this));
    }

    setMovementSpeed(speed) {
        this.movementSpeed = speed;
    }

    resetCamera() {
        this.camera.reset();
    }
}
